import React, { Context } from 'react';
import { AppContextInterface, AppContext } from '../app-context-provider';
import { CategorisedItem } from './categorised-archve';
import PageGrid from '../components/page-grid';
import { PhotoComponentProps } from '../components/photo-component';
// import { PageProps } from '../components/component-switcher';

export interface StyleTag {
  name: string;
  items: PhotoComponentProps[];
}

export interface ArchiveCategoryProps {
  component?: React.ComponentType;
  slug?: string;
  heading?: string;
  key: string;
  itemChildren: CategorisedItem[];
  columns?: number;
  fitContent?: boolean;
}

class ArchiveCategory extends React.Component<ArchiveCategoryProps> {
  pageBodyRef: React.RefObject<any> = React.createRef();
  static contextType: Context<AppContextInterface | null> = AppContext;
  public context!: AppContextInterface;

  renderItems() {
    if (this.props.component === undefined) {
      return null;
    }

    let Component = this.props.component;

    return this.props.itemChildren?.map((item) => <Component {...item} />);
  }

  render() {
    let key = window.btoa(this.props.key);
    return (
      <div className='archive-category' key={'archive-' + key}>
        {this.props.heading && (
          <div
            className='category-heading'
            style={{ color: this.context.styles?.bodyText.dark }}>
            <h3>{this.props.heading}</h3>
          </div>
        )}
        <PageGrid
          className='archive-grid'
          columns={this.props.columns}
          fitContent={this.props.fitContent}>
          {this.props.children}
        </PageGrid>
      </div>
    );
  }
}

export default ArchiveCategory;
